import { useNavigate } from "react-router-dom"
import { ArrowLeft, Printer, UserPlus } from "lucide-react"

const ClassDetailHeader = ({ className, classTeacher, studentCount }) => {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8">
      <div>
        <div className="flex items-center gap-2 mb-2">
          <button
            onClick={() => navigate("/class-management")}
            className="text-slate-400 hover:text-teal-600 flex items-center text-sm font-medium transition-colors"
          >
            <ArrowLeft className="w-4 h-4 mr-1" />
            Back to All Classes
          </button>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-2xl bg-pink-100 text-pink-600 flex items-center justify-center font-bold text-xl border border-pink-200">
            S2
          </div>
          <div>
            <h2 className="text-2xl font-bold text-slate-800">{className} Class Overview</h2>
            <p className="text-slate-500 mt-0.5 text-sm">
              Class Teacher: <span className="font-medium text-slate-700">{classTeacher}</span> • {studentCount}{" "}
              Students
            </p>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <button className="flex items-center gap-2 px-4 py-2.5 rounded-xl border border-slate-200 bg-white text-slate-700 font-medium text-sm hover:bg-slate-50 transition-colors">
          <Printer className="w-5 h-5" />
          Report
        </button>
        <button className="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-teal-600 text-white font-medium text-sm hover:bg-teal-700 transition-colors shadow-sm shadow-teal-600/30">
          <UserPlus className="w-5 h-5" />
          Add Student
        </button>
      </div>
    </div>
  )
}

export default ClassDetailHeader